module.exports = __webpack_public_path__ + "static/media/XIXe.13408adc.png";